/**
 * Base error class for BookingJS
 */
export class BookingJSError extends Error {
  constructor(message, code) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    Error.captureStackTrace(this, this.constructor);
  }
}

/**
 * Error thrown when a booking conflicts with an existing reservation
 */
export class BookingConflictError extends BookingJSError {
  constructor(message = 'Booking conflicts with existing reservation', conflictingBooking = null) {
    super(message, 'BOOKING_CONFLICT');
    this.conflictingBooking = conflictingBooking;
  }
}

/**
 * Error thrown when requested time slot is not available
 */
export class InvalidTimeSlotError extends BookingJSError {
  constructor(message = 'Requested time slot is not available') {
    super(message, 'INVALID_TIME_SLOT');
  }
}

/**
 * Error thrown when member lacks required permissions
 */
export class MemberPermissionError extends BookingJSError {
  constructor(message = 'Member lacks required permissions', memberId = null) {
    super(message, 'MEMBER_PERMISSION');
    this.memberId = memberId;
  }
}

/**
 * Error thrown for data validation failures
 */
export class ValidationError extends BookingJSError {
  constructor(message = 'Data validation failed', field = null, value = null) {
    super(message, 'VALIDATION_ERROR');
    this.field = field;
    this.value = value;
  }
}

/**
 * Error thrown when booking type is not allowed on green/rink
 */
export class BookingTypeNotAllowedError extends BookingJSError {
  constructor(message = 'Booking type is not allowed on this green/rink', bookingTypeId = null, location = null) {
    super(message, 'BOOKING_TYPE_NOT_ALLOWED');
    this.bookingTypeId = bookingTypeId;
    this.location = location;
  }
} 